export default __webpack_public_path__ + "static/media/rm-banner-desktop.affc1fc6.png";